import React, { Component } from 'react'
import {MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavbarToggler, MDBCollapse, MDBContainer, MDBDropdown, 
  MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBRow, MDBCol } from 'mdbreact'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faExternalLink } from '@fortawesome/pro-duotone-svg-icons'
import { Link } from 'gatsby'

class NavBarPage extends Component {
  state = {
    collapsed: false,
  }

  handleTogglerClick = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    })
  }

  componentDidMount() {
    const str = window.location.pathname.substr(
      1,
      window.location.pathname.length - 1
    )
    const len = str.indexOf('/')
    this.setState({
      parentNav: len < 0 ? str : str.substr(0, len),
    })
  }

  render() {
    const overlay = (
      <div
        id="sidenav-overlay"
        style={{ backgroundColor: 'transparent' }}
        onClick={this.handleTogglerClick}
      />
    )

    const isActive = ({ isCurrent }) => {
      return isCurrent ? { className: 'nav-link active' } : {}
    }

    const isPartiallyActive = ({ isPartiallyCurrent }) => {
      return isPartiallyCurrent ? { className: 'nav-link active' } : {}
    }

    return (
      <div>
        <MDBNavbar
          color="top-nav-collapse"
          dark
          expand="lg"
          fixed="top"
          scrolling
          transparent
        >
          <MDBContainer>
            <MDBNavbarBrand>
              <Link to="/">
                <img
                  src="/macro-4-logo-we.svg"
                  alt="Company logo"
                  title="Macro 4"
                  height="32"
                />
              </Link>
            </MDBNavbarBrand>
            <MDBNavbarToggler
              aria-label="Mobile Navigation Button"
              onClick={this.handleTogglerClick}
            />
            <MDBCollapse isOpen={this.state.collapsed} navbar>
              <MDBNavbarNav right>
                <MDBNavItem>
                  <MDBDropdown>
                    <MDBDropdownToggle nav caret className={ this.state.parentNav === 'solutions' ? 'active' : '' } >
                      <span className="mr-1">Solutions</span>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu className="dropdown-ug dropdown-ug-wide">
                      <MDBRow><MDBCol md="4"><MDBDropdownItem href="/solutions/"> Solutions </MDBDropdownItem></MDBCol></MDBRow>

                      <MDBRow className="align-items-top pt-3">
                        <MDBCol md="12" lg="4">
                          <MDBDropdownItem href="/solutions/enterprise-information-management/">
                            Enterprise information management
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/customer-communications-management/" className="dropdown-sub-item">
                            - Customer communications management
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/customer-and-employee-self-service/" className="dropdown-sub-item">
                            - Customer and employee self-service
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/data-management/" className="dropdown-sub-item">
                            - Data management
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/document-data-archiving/" className="dropdown-sub-item">
                            - Document and data archiving
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/information-governance/" className="dropdown-sub-item">
                            - Information governance & compliance
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/legacy-application-decommissioning/" className="dropdown-sub-item">
                            - Legacy application decommissioning
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/output-management/" className="dropdown-sub-item">
                            - Output management
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/sap-solutions/" className="dropdown-sub-item">
                            - SAP solutions
                          </MDBDropdownItem>
                        </MDBCol>

                        <MDBCol md="12" lg="4"> 
                          <MDBDropdownItem href="/solutions/accounts-receivable/">
                            Accounts receivable solutions
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/credit-management/" className="dropdown-sub-item">
                            - Credit management
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/einvoicing/" className="dropdown-sub-item">
                            - eInvoicing
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/sales-order-processing/" className="dropdown-sub-item">
                            - Sales order processing
                          </MDBDropdownItem>
                          <div className="nav-blank">
                            &nbsp;
                          </div>
                          <MDBDropdownItem href="/solutions/digital-transformation/">
                            Digital transformation
                          </MDBDropdownItem>
                        </MDBCol>

                        <MDBCol md="12" lg="4">
                          <MDBDropdownItem href="/solutions/mainframe-solutions/">
                            Mainframe solutions
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/mainframe-application-performance-management/" className="dropdown-sub-item">
                            - Application performance management
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/mainframe-devops/" className="dropdown-sub-item">
                            - DevOps
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/mainframe-fault-resolution/" className="dropdown-sub-item">
                            - Fault resolution
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/ibm-session-manager-replacement/" className="dropdown-sub-item">
                            - IBM Session Manager replacement
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/mainframe-modernization/" className="dropdown-sub-item">
                            - Mainframe modernization
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/session-management/" className="dropdown-sub-item">
                            - Session management
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/mainframe-testing-and-debugging/" className="dropdown-sub-item">
                            - Testing and debugging
                          </MDBDropdownItem>
                          <MDBDropdownItem href="/solutions/mainframe-data-management/" className="dropdown-sub-item">
                            - z/OS data management
                          </MDBDropdownItem>
                        </MDBCol>
                      </MDBRow>

                      {/* <MDBDropdownItem href="/solutions/">
                        Solutions
                      </MDBDropdownItem>
                      <hr className="nav" />
                      <MDBDropdownItem href="/solutions/digital-transformation/">
                        - Digital transformation
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/solutions/enterprise-information-management/">
                        - Enterprise information management
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/solutions/customer-communications-management/">
                        - Customer communications management
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/solutions/legacy-application-decommissioning/">
                        - Application decommissioning
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/solutions/customer-and-employee-self-service/">
                        - Customer and employee self-service
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/solutions/information-governance/">
                        - Information governance and compliance
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/solutions/accounts-receivable/">
                        - Accounts receivable and order to cash
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/solutions/sap-solutions/">
                        - Solutions for SAP
                      </MDBDropdownItem>
                      <hr className="nav" />
                      <MDBDropdownItem href="/solutions/session-management/">
                        - Session management
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/solutions/data-management/">
                        - Data management
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/solutions/fault-analysis-testing/">
                        - Fault analysis and testing
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/solutions/performance-management/">
                        - Performance management
                      </MDBDropdownItem> */}
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavItem>

                <MDBNavItem>
                <Link to="/products/" getProps={isPartiallyActive} className="nav-link">
                    Products
                  </Link>
                </MDBNavItem>

                <MDBNavItem>
                  <MDBDropdown>
                    <MDBDropdownToggle nav caret className={ this.state.parentNav === 'services' ? 'active' : '' } >
                      <span className="mr-1">Services</span>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu className="dropdown-ug">
                      <MDBDropdownItem href="/services/">
                        Services
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/services/professional-services/">
                        - Professional Services
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/services/training/">
                        - Training
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/services/technical-support/">
                        - Support
                      </MDBDropdownItem>
                      <MDBDropdownItem href="https://support.macro4.com" target="_blank">
                        - Customer portal
                        <FontAwesomeIcon
                          icon={faExternalLink}
                          className="ml-2"
                        />
                      </MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavItem>


                <MDBNavItem>
                <Link to="/partners/" getProps={isPartiallyActive} className="nav-link">
                    Partners
                  </Link>
                </MDBNavItem>

                <MDBNavItem>
                  <MDBDropdown>
                    <MDBDropdownToggle nav caret 
                      className={ (this.state.parentNav === 'about' || 
                      this.state.parentNav === 'blog' || 
                      this.state.parentNav === 'careers' || 
                      this.state.parentNav === 'contact' || 
                      this.state.parentNav === 'events' || 
                      this.state.parentNav === 'news' || 
                      this.state.parentNav === 'resources') 
                      ? 'active' : '' } >
                      <span className="mr-1">Company</span>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu className="dropdown-ug">
                      <MDBDropdownItem href="/contact/">
                        Contact us
                      </MDBDropdownItem>
                      <hr className="nav" />
                      <MDBDropdownItem href="/blog/">
                        Blog
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/events/">
                        Events
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/news/">
                        Newsroom
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/resources/">
                        Resources
                      </MDBDropdownItem>
                      <hr className="nav" />
                      <MDBDropdownItem href="/about/">
                        About Us
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/careers/">
                        Careers
                      </MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavItem>

                <MDBNavItem>
                  <a href="/search/" className="nav-link d-none d-lg-block" aria-label="Search">
                    <FontAwesomeIcon icon={faSearch} />
                  </a>
                  <a href="/search/" className="nav-link d-lg-none d-sm-block" aria-label="Search">
                    Search
                  </a>
                </MDBNavItem>

              </MDBNavbarNav>
            </MDBCollapse>
          </MDBContainer>
        </MDBNavbar>
        {this.state.collapsed && overlay}
      </div>
    )
  }
}

export default NavBarPage